/* 🤖 this file was generated by svg-to-ts */
export const matIconMp: {
  name: 'mp';
  data: string;
} = {
  name: 'mp',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M17 9h-3.5v6H15v-1.5h2c.55 0 1-.45 1-1V10c0-.55-.45-1-1-1zm-.5 3H15v-1.5h1.5V12zm-5-3H7c-.55 0-1 .45-1 1v5h1.5v-4.5h1v3H10v-3h1V15h1.5v-5c0-.55-.45-1-1-1z"/><path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM5 19V5h14v14H5z"/></svg>`
};
